type CountTone = 'neutral' | 'attention';

const PILL_TONES: Record<CountTone, string> = {
    neutral: 'bg-gray-200 text-gray-700',
    attention: 'bg-yellow-100 text-yellow-800'
};

interface CountPillProps {
    count: number;
    tone?: CountTone;
}

export function CountPill({ count, tone = 'neutral' }: CountPillProps) {
    return (
        <span
            className={`inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold leading-none ${PILL_TONES[tone]}`}
        >
            {count}
        </span>
    );
}

interface CountTabLabelProps {
    label: string;
    /** null while the count is unknown (loading or failed): the label renders bare. */
    count: number | null;
    showZero?: boolean;
    tone?: CountTone;
}

export function CountTabLabel({ label, count, showZero = false, tone }: CountTabLabelProps) {
    const visible = count !== null && (showZero || count > 0);
    return (
        <span className="inline-flex items-center gap-1.5">
            {label}
            {visible && <CountPill count={count} tone={tone} />}
        </span>
    );
}
